export const CHANGE_SORTING = 'CHANGE_SORTING';
